/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NavigateTo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NavigateTo({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/CustomResource/Content/Content/CustomResource/Content/Resource/Trigger/NavigateTo"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let customResourceItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource_item',
path: 'isFirst',
})
let customResourceLinkValueData = fromData.useDataValue({ viewPath,
context: 'custom_resource',
path: 'link',
})
let aggregateData = fromHelpers.getView(customResourceItemIsFirstValueData, customResourceLinkValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}